import { Loader2 } from "lucide-react";
import { formatDate, tagClass } from "@/components/decodes/format";

export default function DecodesGrid({ loading, items, admin, onOpen }) {
  if (loading) {
    return (
      <div className="flex justify-center p-10 muted">
        <Loader2 className="animate-spin" size={20} />
      </div>
    );
  }
  if (items.length === 0) {
    return (
      <div className="panel p-10 text-center muted font-mono text-sm">
        No decodes yet. {admin && "Hit \"New Decode\" to publish your first one."}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="decode-list">
      {items.map((d) => (
        <button
          key={d.id}
          onClick={() => onOpen(d)}
          className="panel panel-hover p-5 text-left group transition-transform hover:-translate-y-[2px]"
          data-testid={`decode-card-${d.id}`}
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.18em] muted mb-2">
            {formatDate(d.created_at)} · {d.author}
          </div>
          <h3 className="font-display text-2xl tracking-tight leading-snug group-hover:text-[var(--primary)] transition-colors">
            {d.title}
          </h3>
          <p className="muted text-sm font-mono mt-2 line-clamp-3 leading-relaxed">
            {d.body.slice(0, 240)}{d.body.length > 240 && "…"}
          </p>
          {d.tags && d.tags.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-3">
              {d.tags.slice(0, 6).map((t) => <span key={t} className={tagClass(t)}>{t}</span>)}
            </div>
          )}
        </button>
      ))}
    </div>
  );
}
